export default __webpack_public_path__ + "static/media/Composting.443effee.pdf";